//
// AVAILS
//
export const SET_AVAILS = 'SET_AVAILS';

//
// DEMOGRAPHICS
//
export const SET_DEMOGRAPHICS = 'SET_DEMOGRAPHICS';

//
// EXCHANGE
//
export const SET_EXCHANGE = 'SET_EXCHANGE';
export const SET_EXCHANGE_SETTINGS = 'SET_EXCHANGE_SETTINGS';
export const SET_SUPPLIERS = 'SET_SUPPLIERS';

//
// GEOFENCE_GROUPS
//
export const SET_GEOFENCE_GROUPS = 'SET_GEOFENCE_GROUPS';
export const SET_GEOFENCE_GROUPS_EXCLUDED = 'SET_GEOFENCE_GROUPS_EXCLUDED';

//
// LANGUAGES
//
export const SET_LANGUAGES = 'SET_LANGUAGES';

//
// LOCATIONS
//
export const SET_LOCATIONS = 'SET_LOCATIONS';
export const SET_LOCATIONS_EXCLUDED = 'SET_LOCATIONS_EXCLUDED';

//
// LINEITEMS
//
export const SET_LINEITEM = 'SET_LINEITEM';
export const SET_LINEITEMS = 'SET_LINEITEMS';
export const SET_TOTAL_LINEITEMS = 'SET_TOTAL_LINEITEMS';

//
// MARKETS
//
export const SET_MARKETS = 'SET_MARKETS';

//
// MEDIA_TYPES
//
export const SET_MEDIA_TYPES = 'SET_MEDIA_TYPES';

//
// NETWORKS
//
export const SET_NETWORKS = 'SET_NETWORKS';

//
// ORGANIZATION DSPS
//
export const SET_ORGANIZATION_DSPS = 'SET_ORGANIZATION_DSPS';

//
// PACKAGES
//
export const SET_PACKAGE = 'SET_PACKAGE';
export const SET_PACKAGES = 'SET_PACKAGES';
export const SET_TOTAL_PACKAGES = 'SET_TOTAL_PACKAGES';
export const UPDATE_PACKAGES = 'UPDATE_PACKAGES';
export const DELETE_PACKAGE = 'DELETE_PACKAGE';

//
// PERMISSIONS
//
export const SET_PERMISSIONS = 'SET_PERMISSIONS';

//
// SITES
//
export const SET_SITES = 'SET_SITES';
export const SET_SITES_EXCLUDED = 'SET_SITES_EXCLUDED';

//
// TARGETING CRITERIA
//
export const SET_TARGETING_CRITERIA = 'SET_TARGETING_CRITERIA';

//
// UNITS
//
export const SET_UNITS = 'SET_UNITS';
export const SET_UNITS_EXCLUDED = 'SET_UNITS_EXCLUDED';

//
// UNIT PACKS
//
export const SET_UNIT_PACKS = 'SET_UNIT_PACKS';
